// import { Box, Grid, MenuItem, SxProps } from '@mui/material';
// import React from 'react'
// import InputTextField from '../input/inputTextField';
// import AutocompleteSelect from '../select/autoCompleteSelect';
// import InputDatePicker from '../input/inputDatePicker';
// import FilterSelect from '../select/filterSelect';
// import moment from 'moment';
// import TextEditorCustom from '../text-editor/TextEditorCustom';
// import UploadFile from '../upload/UploadFile';
// import InputTextMask from '../input/InputTextMask';
// import RadioCustom from '../radio/RadioCustom';
// import TextEditorCustom from '../text-editor/TextEditorCustom';

import { Box, FormLabel, Grid, MenuItem, Stack, SxProps, Typography, TypographyOwnProps } from "@mui/material";
import React from "react";
import InputTextField, { InputProps } from "../input/inputTextField";
import InputTextMask, { MaskProps } from "../input/inputTextMask";
import AutocompleteSelect from "../select/autoCompleteSelect";
import InputDatePicker from "../input/inputDatePicker";
import moment from "moment";
import FilterSelect, { BasicSelectProps } from "../select/filterSelect";
import TextEditorCustom from "../text-editor/TextEditorCustom";
import UploadFile from "../upload/UploadFile";
import RadioCustom from "../radio/RadioCustom";
import InputNewRangePicker, { DateRangePickerType } from "../input/inputRankPicker";
import ContainerButton, { ButtonCustomProps } from "../button/ContainerButton";
import TimePickerCustom, { TimeProps } from "../time-picker/TimePicker";
import SwitchCustom, { SwitchPropsCustom } from "../switch/SwitchCustom";
import { UploadImagePreview, uploadImageProps } from "../upload-image-preview/UploadImagePreview";
import DateRankPicker, { dateRangeProps } from "../input/inputDateRangePicker";
import ImageTracking, { ImageTrackingProps } from "../upload/MultiUploadFile";
import ColorPicker, { colorProps } from "../color-picker/ColorPicker";
import { isArray } from "lodash";

export type gridColType = {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
};

// export type TEXT_FIELD_TYPE = {
//     value?: string;
//     onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
//     heading?: string;
//     helperText?: string;
//     placeholder?: string;
//     startAdornment?: React.ReactNode;
//     enableTextArea?: {};
//     disabled?: boolean;
//     otherProps?: any;
//     required?: boolean;
//     onKeyDown?: (e: any) => void;
//     disablePaddingMultiline?: boolean;
//     inputHeight?: any;
//     row?: number;
//     maxRows?: number;
//     minRow?: number;
//     type?: any;
//     multiline?: boolean;
//     disableColor?: string;
//     endAdornment?: React.ReactNode;
//     onblur?: (value: any) => void;
//     onkeypress?: any;
//     noBorder?: boolean;
// };
// export type TEXT_MASK_TYPE = {
//     mode: 'amount' | 'phone' | 'thai-id' | 'number' | 'latlng';
//     value?: string;
//     onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
//     headingAlign?: React.CSSProperties['textAlign'];
//     heading?: string;
//     helperText?: string;
//     placeholder?: string;
//     startAdornment?: React.ReactNode;
//     enableTextArea?: {};
//     disabled?: boolean;
//     otherProps?: any;
//     required?: boolean;
//     disableColor?: string;
// };
export type AUTO_COMPLETE_TYPE = {
    value: any;
    onChange: (event?: any, val?: any, mode?: string) => void;
    heading?: string;
    helperText?: string;
    placeholder?: string;
    labelId: string;
    options: any[];
    required?: boolean;
    otherProps?: any;
    disabled?: boolean;
    onInputChange?: any;
    inputValue?: string;
    freesolo?: boolean;
    limitTags?: number;
    groupBy?: any;
    renderGroup?: any;
    disableCloseOnSelect?: boolean;
    multiple?: boolean;
    isOptionEqualToValue?: any;
    getOptionLabel: (option: any) => string;
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
    renderTags?: (props: any, option: any) => any
    getOptionDisabled?: any;

};
export type DATE_TYPE = {
    value: string;
    onChange: (date_format: string) => void;
    heading?: string;
    placeholder?: string;
    otherProps?: any;
    allowClear?: boolean;
    required?: boolean;
    sx?: SxProps;
    onClear?: () => void;
    helperText?: string;
    disabled?: boolean;
    disableStartDate?: any;
    disableEndDate?: any;
};

// export type SELECT_TYPE = {
//     onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
//     heading?: string;
//     options: { label: string; value: string | number, icon?: React.ReactNode }[];
//     placeholder?: string;
//     otherProps?: any;
//     required?: boolean;
//     labelId: string;
//     selectId: string;
//     disabled?: boolean;
//     value: any;
//     helperText?: string;
//     renderValue?: (option: any) => any;
//     formControlStyle?: SxProps;
//     onCheckBox?: (event: any) => void;
//     checkBoxValue?: string[] | number[];
//     multiple?: boolean;
// };
export type COMPONENT_TYPE = {
    element: React.ReactNode;
    heading?: string;
}
type dataType = {
    value: string;
    label: string;
    sx?: SxProps;
    renderAfter?: React.ReactNode;
}

export type RADIO_TYPE = {
    sx?: SxProps;
    heading?: string;
    dataList: dataType[];
    defaultValue?: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    row?: boolean;
    disabled?: boolean;
    labelClassName?: string;
    headingBold?: string;
    subHeadingBold?: string;
    required?: boolean;
}
export type TEXT_EDITOR_TYPE = {
    textString: string;
    onChange: (text: string) => void;
    sx?: SxProps;
    height?: string;
    disabled?: boolean;
    heading?: string;
    placeholder?: string;
};
export type UPLOAD_FILE_TYPE = {
    heading?: string;
    onDrop: (data: any) => void;
    file?: any
    onDeleteFile?: () => void;
    fileAttachmentId?: number;
    fileAttachmentName?: string;
    noClick?: boolean;
    required?: boolean;
    helperText?: string;
    hidden?: boolean
    dispatchLoading?: any
    xlSize?: boolean;
    formatText?: string;
    enableFormatImage?: boolean;
    showImage?: boolean;
    fileName?: string;
    pathImage?: string;
    formatValidate?: string[];
    onDeleteFileId?: () => void;
    disableDeleteFileId?: boolean;
    notFoundFileText?: string;
    containerHeight?: string;
    onDownloadFile?: () => void;
    hiddenDownloadFile?: boolean;
    viewButtonWithPath?: string;
    customFormat?: string[];
    containerBorder?: string;
    fileSize?: number;
    headingLight?: boolean;
    enableTopButtonAddFile?: boolean;
    onlyPdf?:boolean;
};

export type FilterProps =
    | {
        type: "TEXT_FIELD";
        seq: number;
        fieldProps: InputProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "AUTO-COMPLETE";
        seq: number;
        fieldProps: AUTO_COMPLETE_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "DATE";
        seq: number;
        fieldProps: DATE_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "SELECT";
        seq: number;
        fieldProps: BasicSelectProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "COLOR_PICKER";
        seq: number;
        fieldProps: colorProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "TEXT-EDITOR";
        seq: number;
        fieldProps: TEXT_EDITOR_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "TEXT-EDITOR";
        seq: number;
        fieldProps: TEXT_EDITOR_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "UPLOAD-FILE";
        seq: number;
        fieldProps: UPLOAD_FILE_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "UPLOAD_IMAGE_PREVIEW";
        seq: number;
        fieldProps: uploadImageProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "TEXT-MASK"
        seq: number;
        fieldProps: MaskProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "COMPONENT";
        seq: number;
        fieldProps: COMPONENT_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "DATE_RANGE2";
        seq: number;
        fieldProps: dateRangeProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "RADIO";
        seq: number;
        fieldProps: RADIO_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "SWITCH";
        seq: number;
        fieldProps: SwitchPropsCustom;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "MULTI_UPLOAD_IMAGE";
        seq: number;
        fieldProps: ImageTrackingProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "DATE_RANGE";
        seq: number;
        fieldProps: DateRangePickerType;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    } | {
        type: "BUTTON";
        seq: number;
        fieldProps: ButtonCustomProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "TIME_PICKER";
        seq: number;
        fieldProps: TimeProps;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    };


type Props = {
    typeProps: FilterProps[];
    otherProps?: { spacing?: number }
    sxContainer?: SxProps;
    heading?: string;
    headingAlign?: React.CSSProperties['justifyContent']
    headingClassName?: string;
    headingContent?: React.ReactNode;
    disabledAllField?: boolean;
    sx?: SxProps;
    heading_props?: {
        variantHeading?: TypographyOwnProps['variant'];
        fontSize?: TypographyOwnProps['fontSize'];
    }
}


const StateComponents = (props: Props) => {
    const { typeProps, otherProps, heading_props, sxContainer, heading, headingAlign, headingClassName, disabledAllField } = props
    return (
        <Box sx={sxContainer}>
            {heading && (
                <Box sx={{
                    display: "flex", flexDirection: {
                        xs: "column",
                        lg: "row"
                    }
                }} justifyContent={headingAlign} className={`w-full gap-4 ${headingClassName}`}>
                    <Typography whiteSpace={"nowrap"} fontSize={heading_props?.fontSize} my={1} variant={heading_props?.variantHeading || "h5"}>
                        {heading}
                    </Typography>
                    {props.headingContent}
                </Box>
            )}
            <Grid container spacing={otherProps?.spacing} >
                {typeProps.filter((x) => !x.hidden).sort((x, y) => x.seq - y.seq).map((list) => {
                    return (
                        <React.Fragment key={list.seq}>
                            {(() => {
                                switch (list.type) {
                                    case 'TEXT_FIELD':
                                        return <Grid item key={list.seq} {...list.gridProps} >
                                            <InputTextField
                                                {...list.fieldProps}
                                                {...(list.fieldProps.enableTextArea && {})}
                                                disabled={disabledAllField || list.fieldProps.disabled}
                                                onchange={list.fieldProps.onChange}
                                            />
                                        </Grid>
                                    case 'TEXT-MASK':
                                        return <Grid item key={list.seq} {...list.gridProps} >
                                            <InputTextMask
                                                {...list.fieldProps}
                                                disabled={disabledAllField || list.fieldProps.disabled}
                                                onChange={list.fieldProps.onChange}
                                            />
                                        </Grid>
                                    case 'AUTO-COMPLETE':
                                        return <Grid item key={list.seq} {...list.gridProps} >
                                            <AutocompleteSelect {...list.fieldProps}
                                                disabled={disabledAllField || list.fieldProps.disabled}
                                            />
                                        </Grid>
                                    case 'DATE':
                                        return <Grid item key={list.seq} {...list.gridProps} >
                                            <InputDatePicker
                                                {...list.fieldProps}
                                                disabled={disabledAllField || list.fieldProps.disabled}
                                                onChange={(e: any) => list.fieldProps.onChange(moment(e).format("YYYY-MM-DD"))}
                                            />
                                        </Grid>
                                    case 'SELECT': return <Grid item key={list.seq} {...list.gridProps} >
                                        <FilterSelect {...list.fieldProps}
                                            onchange={list.fieldProps.onChange}
                                            disabled={disabledAllField || list.fieldProps.disabled}
                                            options={isArray(list.fieldProps?.options) ? list.fieldProps?.options.map((op, i: number) =>
                                                <MenuItem value={op?.value} key={i + 1}>
                                                    <Stack px={2} direction="row" spacing={1} sx={{
                                                        alignContent: 'center', alignItems: 'center', cursor: "pointer", '&:hover': {
                                                            opacity: .6
                                                        }
                                                    }}>
                                                        {op.icon && (<Box sx={{ position: 'relative', width: 30, height: 30, display: 'flex', alignItems: 'center' }}>{op.icon}</Box>)}
                                                        <span>{op.label}</span>
                                                    </Stack>
                                                </MenuItem>
                                            ) : list.fieldProps.options}
                                        />
                                    </Grid>
                                    case 'TEXT-EDITOR':
                                        return <Grid item key={list.seq} {...list.gridProps}>
                                            <TextEditorCustom {...list.fieldProps}
                                                disabled={disabledAllField || list.fieldProps.disabled}
                                            />
                                        </Grid>
                                    case 'UPLOAD-FILE':
                                        return (
                                            <Grid item key={list.seq} {...list.gridProps}>
                                                <UploadFile  {...list.fieldProps}
                                                    noClick={disabledAllField || list.fieldProps.noClick}
                                                />
                                            </Grid>
                                        );
                                    case 'MULTI_UPLOAD_IMAGE':
                                        return (
                                            <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                                <ImageTracking {...list.fieldProps} />
                                            </Grid>
                                        );
                                    case 'COLOR_PICKER':
                                        return (
                                            <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                                <ColorPicker
                                                    disabled={props.disabledAllField || list.fieldProps.disabled}
                                                    {...list.fieldProps} />
                                            </Grid>
                                        );
                                    case 'UPLOAD_IMAGE_PREVIEW':
                                        return (
                                            <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                                <UploadImagePreview
                                                    {...list.fieldProps}
                                                    disabled={props.disabledAllField || list.fieldProps.disabled}
                                                />
                                            </Grid>
                                        );
                                    case 'COMPONENT':
                                        return (
                                            <Grid item key={list.seq} {...list.gridProps}>
                                                {list.fieldProps.element}
                                            </Grid>
                                        );
                                    case 'TIME_PICKER':
                                        return (
                                            <Grid item key={list.seq} {...list.gridProps}>
                                                <TimePickerCustom
                                                    disabled={props.disabledAllField || list.fieldProps.disabled}
                                                    {...list.fieldProps} />
                                            </Grid>
                                        );
                                    case 'SWITCH':
                                        return (
                                            <Grid item key={list.seq} {...list.gridProps}>
                                                <SwitchCustom {...list.fieldProps} />
                                            </Grid>
                                        );
                                    case 'DATE_RANGE':
                                        return (
                                            <Grid item key={list.seq} {...list.gridProps}>
                                                <InputNewRangePicker disabled={disabledAllField || list.fieldProps.disabled} {...list.fieldProps} />
                                            </Grid>
                                        );
                                    case 'DATE_RANGE2':
                                        return (
                                            <Grid item key={list.seq} {...list.gridProps}>
                                                <DateRankPicker
                                                    {...list.fieldProps}
                                                    disabled={props.disabledAllField || list.fieldProps.disabled}
                                                />
                                            </Grid>
                                        );
                                    case 'BUTTON':
                                        return (
                                            <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                                <ContainerButton
                                                    sxContainer={{
                                                        width: "100%",
                                                        maxWidth: "100%",
                                                        height: "100%",
                                                        display: 'flex',
                                                        justifyContent: 'flex-start',
                                                        alignItems: 'end'
                                                    }}
                                                    className='w-full mb-2 max-h-[45px]'
                                                    {...list.fieldProps}
                                                    buttonData={list.fieldProps.buttonData}
                                                />
                                            </Grid>
                                        );
                                    case 'RADIO':
                                        return (
                                            <Grid item key={list.seq} {...list.gridProps}>
                                                <RadioCustom disabled={disabledAllField || list.fieldProps.disabled} {...list.fieldProps} />
                                            </Grid>
                                        );
                                    default:
                                        return null;
                                }
                            })()}
                        </React.Fragment>
                    )
                })}
            </Grid>
        </Box>
    )
}

export default StateComponents